export default {
    stats: [],
    statsForExport: [],
    profit: {},
    allOrders: []
}